export const BrandLogo = () => {
    return (
        <svg width="58" height="58" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_424_9022)">
                <path
                    d="M5.66675 8.49966C5.66675 5.47818 9.58301 5.47779 9.58301 8.49963C9.58301 11.5215 9.58301 11.8422 11.5411 11.8419C13.4993 11.8415 16.55 11.8992 18.889 14.8107C18.889 14.8107 18.7446 16.3927 18.9304 17.3579C19.8778 22.279 25.6206 20.0229 27.457 21.2948C30.2992 23.2632 25.5622 27.2001 22.72 23.2632C22.1516 22.4758 18.9304 21.9129 18.9304 24.9341C18.9304 25.0593 18.9244 25.1792 18.913 25.294C18.6487 27.9502 15.4574 27.8302 15.4574 24.9341C15.4574 21.9129 15.4574 24.3387 15.4574 20.3104C15.4574 16.2821 9.45636 16.2821 9.45636 20.3104C9.45636 23.3316 5.66675 23.3318 5.66675 20.3105C5.66675 17.2893 5.66675 11.5211 5.66675 8.49966Z"
                    fill="white"/>
            </g>
            <g filter="url(#filter1_d_424_9022)">
                <path
                    d="M28.1688 15.9711C28.9273 17.1348 27.4704 18.3586 26.0885 18.2169C25.0364 18.109 24.0483 17.9901 23.5238 17.6122C20.8598 15.6927 24.9852 12.1175 27.9638 15.6927C28.0378 15.7815 28.106 15.8747 28.1688 15.9711Z"
                    fill="white"/>
            </g>
            <defs>
                <filter id="filter0_d_424_9022" x="2.66675" y="4.2334" width="28.6667" height="26.9668"
                        filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                   result="hardAlpha"/>
                    <feOffset dy="1"/>
                    <feGaussianBlur stdDeviation="1.5"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.54 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_424_9022"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_424_9022" result="shape"/>
                </filter>
                <filter id="filter1_d_424_9022" x="19.6663" y="12.167" width="11.7107" height="10.061"
                        filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                   result="hardAlpha"/>
                    <feOffset dy="1"/>
                    <feGaussianBlur stdDeviation="1.5"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.54 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_424_9022"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_424_9022" result="shape"/>
                </filter>
            </defs>
        </svg>
    );
}